import React, { useRef, useMemo } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";

function Meteors() {
  const meteorCount = 7; // ✅ Počet aktivních meteorů v jednu chvíli
  const meteorRef = useRef([]);

  // Generujeme meteory s náhodnými dráhami
  const meteors = useMemo(() => {
    return Array.from({ length: meteorCount }).map(() => ({
      position: new THREE.Vector3(
        (Math.random() - 0.5) * 2000,
        (Math.random() - 0.5) * 2000,
        (Math.random() - 0.5) * 2000
      ),
      velocity: new THREE.Vector3(
        (Math.random() - 0.5) * 10, // ✅ Zvýšili jsme rychlost!
        (Math.random() - 0.5) * 10,
        (Math.random() - 0.5) * 10
      ),
      size: Math.random() * 0.5 + 0.5,
      color: new THREE.Color(`hsl(${Math.random() * 360}, 100%, 80%)`)
    }));
  }, []);

  useFrame(() => {
    meteors.forEach((meteor, i) => {
      const mesh = meteorRef.current[i];
      if (!mesh) return;

      // Posun meteoru
      mesh.position.add(meteor.velocity);

      // Reset meteoru, pokud vyletí z vesmíru
      if (mesh.position.length() > 2500) {
        mesh.position.set(
          (Math.random() - 0.5) * 2000,
          (Math.random() - 0.5) * 2000,
          (Math.random() - 0.5) * 2000
        );
        meteor.velocity.set(
          (Math.random() - 0.5) * 50, // ✅ Zvýšená rychlost
          (Math.random() - 0.5) * 50,
          (Math.random() - 0.5) * 50
        );
      }
    });
  });

  return (
    <group>
      {meteors.map((meteor, i) => (
        <mesh key={i} ref={(el) => (meteorRef.current[i] = el)} position={meteor.position}>
          <sphereGeometry args={[meteor.size, 16, 16]} />
          <meshStandardMaterial color={meteor.color} emissive={meteor.color} emissiveIntensity={2} />
        </mesh>
      ))}
    </group>
  );
}

export default Meteors;